export { default as OrderPlacementConfirmation } from "./OrderPlacementConfirmation";
export type { IOrderPlacementConfirmationProps } from "./types";
